module.exports = __webpack_public_path__ + "img/vstupenka_bez_ceny.58bb7297.svg";